import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnitedKingdom = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#0052b4",
			children: /* @__PURE__ */ _jsx("path", { d: "M53 100.1a255 255 0 0 0-44.2 89.1H142zM503.2 189.2a255 255 0 0 0-44.1-89l-89.1 89zM8.8 322.8a255 255 0 0 0 44.1 89l89-89zM411.9 53a255 255 0 0 0-89.1-44.2V142zM100.1 459a255 255 0 0 0 89.1 44.2V370zM189.2 8.8a255 255 0 0 0-89 44.1l89 89zM322.8 503.2a255 255 0 0 0 89-44.1l-89-89.1zM370 322.8l89 89a255 255 0 0 0 44.2-89z" })
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#d80027",
			children: [/* @__PURE__ */ _jsx("path", { d: "M509.8 222.6H289.4V2.2a258.6 258.6 0 0 0-66.8 0v220.4H2.2a258.6 258.6 0 0 0 0 66.8h220.4v220.4a258.5 258.5 0 0 0 66.8 0V289.4h220.4a258.5 258.5 0 0 0 0-66.8z" }), /* @__PURE__ */ _jsx("path", { d: "M322.8 322.8 437 437c5.3-5.2 10.3-10.7 15-16.4l-97.7-97.8h-31.5zM189.2 322.8 75 437c5.2 5.3 10.7 10.3 16.4 15l97.8-97.7zM189.2 189.2 75 75a256.6 256.6 0 0 0-15 16.4l97.7 97.8h31.5zM322.8 189.2 437 75a256.3 256.3 0 0 0-16.4-15l-97.8 97.7z" })]
		})
	]
});
export default SvgUnitedKingdom;
